var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80625 10.5969L5.36639 12.3169C4.50791 12.7461 3.90664 13.5602 3.74885 14.5069L3.1225 18.2651C3.04205 18.7477 3.08089 19.2427 3.23563 19.7069L3.31623 19.9487C3.72457 21.1738 4.87099 22 6.16228 22H17.8377C19.129 22 20.2754 21.1738 20.6838 19.9487L20.7644 19.7069C20.9191 19.2427 20.9579 18.7477 20.8775 18.2651L20.2511 14.5069C20.0934 13.5602 19.4921 12.7461 18.6336 12.3169L15.1938 10.5969",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.5C16 7.67838 15.9589 8.92069 15.5 10C14.776 11.7029 13.3521 12 12 12C10.6479 12 9.22402 11.7029 8.5 10C8.04111 8.92069 8 7.67838 8 6.5C8 3.46243 9.79086 2 12 2C14.2091 2 16 3.46243 16 6.5Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.535fccc2441978b82c3cd33fcc6d1001.svg";